import { useEffect } from 'react';
import { useForm, type UseFormReturn } from 'react-hook-form';
import {
  DEFAULT_FORM_VALUES,
  toEditValues,
} from '@/features/experiences/components/ExperienceFormDialog.utils';
import type { ExperienceFormData } from '@/features/experiences/components/ExperienceFormFields';
import type { Experience } from '@/features/experiences/types/experience.types';

export type ExperienceFormFlags = Pick<
  ExperienceFormData,
  'isOngoing' | 'isFullTime' | 'isContractor' | 'continuous' | 'isGig'
>;

export interface CandidateExperienceForm {
  form: UseFormReturn<ExperienceFormData>;
  flags: ExperienceFormFlags;
}

export function useCandidateExperienceForm(
  mode: 'create' | 'edit',
  experience?: Experience | null
): CandidateExperienceForm {
  const form = useForm<ExperienceFormData>({
    defaultValues: mode === 'edit' && experience ? toEditValues(experience) : DEFAULT_FORM_VALUES,
  });
  const { reset, watch } = form;

  useEffect(() => {
    if (mode === 'edit' && experience) reset(toEditValues(experience));
    else if (mode === 'create') reset(DEFAULT_FORM_VALUES);
  }, [experience, mode, reset]);

  return {
    form,
    flags: {
      isOngoing: watch('isOngoing'),
      isFullTime: watch('isFullTime'),
      isContractor: watch('isContractor'),
      continuous: watch('continuous'),
      isGig: watch('isGig'),
    },
  };
}
